import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import StickyRail from '../components/Home/StickyRail';
import Timeline from '../components/Home/Timeline';
import ProjectSection from '../components/Projects/ProjectSection';
import scrollToSection from '../components/Utils/scrollToSection';
import styles from './Home.module.css';

/**
 * Two-column home page: a sticky portrait rail on the left, the vertical
 * experience timeline on the right, then the grouped project grid full-width
 * below. Collapses to a single column under 1024px, where the rail unsticks.
 */
export default function Home() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const target = state?.scrollTo;

  // Arriving from a detail page via the nav's "Projects" link. ScrollToTop
  // resets us to the top on every route change, so defer past this commit's
  // effects before jumping. A timeout, not requestAnimationFrame: rAF never
  // fires while the tab is backgrounded, which would silently drop the jump.
  useEffect(() => {
    if (!target) return undefined;

    const t = setTimeout(() => {
      scrollToSection(target);
      // Clear the state so returning here later doesn't re-trigger the jump.
      navigate('/', { replace: true, state: null });
    }, 0);

    return () => clearTimeout(t);
  }, [target, navigate]);

  return (
    <main className={styles.page}>
      <div className={`${styles.split} mc-shell`}>
        <StickyRail />
        <Timeline />
      </div>

      <div className="mc-shell">
        <ProjectSection />
      </div>
    </main>
  );
}
